import { Select } from "@mui/material";
import MenuItemWithoutHighlight from "@entrilia/shared/components/MenuItemWithoutHighlight";
import StatusChip from "@entrilia/shared/components/StatusChip";
import CategoryTag from "../../../../../common/CategoryTag";
import useFundraisingDetailsPageContext from "../useFundraisingDetailsPageContext";

interface Props {
  externalCategoryId: string | undefined;
  onChange: (externalCategoryId: string | undefined) => void;
  variant?: "outlined" | "standard";
  fullWidth?: boolean;
  disabled?: boolean;
}

const FundraisingCategorySelect = ({ externalCategoryId, onChange, variant, fullWidth, disabled }: Props) => {
  const { fundraisingCategories } = useFundraisingDetailsPageContext();

  return (
    <Select
      variant={variant}
      fullWidth={fullWidth}
      disableUnderline={variant === "standard"}
      value={externalCategoryId ?? ""}
      displayEmpty
      disabled={disabled}
      renderValue={(value) =>
        fundraisingCategories.some((c) => c.externalId === value) ? (
          <CategoryTag externalCategoryId={value} />
        ) : (
          <StatusChip label="No category" color={(t) => t.palette.text.secondary} neutral />
        )
      }
      onChange={(e) => onChange(e.target.value || undefined)}
      sx={{
        ".MuiInputBase-input": {
          "&:focus": {
            backgroundColor: "transparent",
          },
        },
      }}
    >
      <MenuItemWithoutHighlight value="">
        <StatusChip label="No category" color={(t) => t.palette.text.secondary} neutral />
      </MenuItemWithoutHighlight>
      {fundraisingCategories.map((category) => (
        <MenuItemWithoutHighlight key={category.externalId} value={category.externalId}>
          <CategoryTag externalCategoryId={category.externalId} />
        </MenuItemWithoutHighlight>
      ))}
    </Select>
  );
};

export default FundraisingCategorySelect;
